import React, { useState, useEffect } from "react";
import { AXIOS } from "../api";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import Switch from "react-switch";
import { ChromePicker } from "react-color";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { TwitterPicker } from "react-color";

import { Title, Picture, Heading, Icons, PictureItem } from "./common/Themes";
import { setLoading, setFetch } from "../redux/actions";

const UpdateActivite = () => {
  const dispatch = useDispatch();
  const { activites } = useSelector((state) => state.fetch);
  const { fetch } = useSelector((state) => state.config);

  const [activite, setActivite] = useState({});
  const [name, setName] = useState("");
  const [strings, setStrings] = useState({ string_1: "", string_2: "" });
  const [file, setFile] = useState();
  const [imageURL, setImageURL] = useState("");
  const [menu, setMenu] = useState(false);
  const [redirectStatus, setRedirectStatus] = useState(false);
  const [color, setColor] = useState({
    hex: "#FF5C00",
    rgb: { r: 245, g: 68, b: 46, a: 0.8 },
  });
  const history = useHistory();

  const [primaryColor, setPrimaryColor] = useState("#000");
  const [secondaryColor, setSecondaryColor] = useState("#000");
  const [backgroundColor, setBackgroundColor] = useState("#000");

  const location = useLocation();
  const [, type, aid] = location.pathname.split("/");

  useEffect(() => {
    const activite = activites.filter((item) => item.aid === aid)[0];
    console.log("⚗️ CURRENT ACTIVITÉ: ", activite);
    setActivite(activite);
    setName(activite?.name);
    setColor({ hex: activite?.color });
    setMenu(activite?.menu);
    setRedirectStatus(!!activite?.redirectStatus);

    setPrimaryColor(activite?.colors?.primary);
    setSecondaryColor(activite?.colors?.secondary);
    setBackgroundColor(activite?.colors?.background);

    if (!!activite?.strings) {
      try {
        const STRINGS = activite?.strings
          ?.replace(/\\n/g, "\n")
          .replace(/\\/g, "");
        setStrings(JSON.parse(STRINGS.trim()));
      } catch (error) {
        console.error("Failed to parse JSON:", error.message);
      }
    }

    setStatusSlider(!!activite?.status_slider);

    setImageURL(`${process.env.REACT_APP_SITE_MARCHAND}${activite?.image}`);
    if (activite?.slider)
      setImageSlider(
        `${process.env.REACT_APP_SITE_MARCHAND}${activite?.slider}`
      );
  }, [activites, aid, setActivite, setName, setColor]);

  const { handleSubmit, register, errors } = useForm();

  // DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        setFile(acceptedFiles[0]);
        const reader = new FileReader();
        reader.onload = (event) => {
          setImageURL(event.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
  });

  const onSubmit = async (values) => {
    try {
      dispatch(setLoading(true));
      const body = {
        ...values,
        color: color.hex,
        menu,
        redirectStatus,
        colors: {
          primary: primaryColor,
          secondary: secondaryColor,
          background: backgroundColor,
        },
        strings: JSON.stringify({
          string_1: values?.topText?.replace(/\n/g, "<br/>"),
          string_2: values?.bottomText?.replace(/\n/g, "<br/>"),
        }),
        image: `/uploads/activites/image/${aid}.png?cache=${new Date().getTime()}`,

        status_slider: statusSlider,
        slider: `/uploads/activites/image/slider-${aid}.png?cache=${new Date().getTime()}`,
      };

      // 👽 UPDATE IMAGE REQUEST
      if (!_.isEmpty(file)) {
        const formData = new FormData();
        formData.append("file", file);
        await AXIOS.post(
          `/api/v1/uploads/activites/${aid}?folder=image`,
          formData
        );
      }

      // 👽 UPDATE IMAGE REQUEST
      if (!!fileSlider?.name && true) {
        console.log("inside : ", fileSlider);
        const formData = new FormData();
        formData.append("file", fileSlider);
        await AXIOS.post(
          `/api/v1/uploads/activites/slider-${aid}?folder=image`,
          formData
        );
      }

      // 👽 UPDATE ACTIVITÉ REQUEST
      await AXIOS.patch(`/api/v1/activites/${aid}`, body);
      history.push("/activites");
      dispatch(setFetch(!fetch));
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  const [imageSlider, setImageSlider] = useState(
    "/img/default_image_slider.png"
  );
  const [fileSlider, setFileSlider] = useState();
  const [statusSlider, setStatusSlider] = useState(false);
  const fileInputSliderRef = React.useRef(null);

  const handleImageSliderChange = (e) => {
    const file = e.target.files[0];

    console.log(file);
    if (file) {
      const reader = new FileReader();
      setFileSlider(file);
      reader.onloadend = () => {
        setImageSlider(reader.result); // Set the base64 image as state
      };
      reader.readAsDataURL(file); // Read the file as data URL
    }
  };

  const handleUploadSliderClick = () => {
    fileInputSliderRef.current.click(); // Trigger the hidden file input
  };

  return (
    <div className="gestion">
      <div className="gestion__header">
        <h4 className="gestion__title">Update activité</h4>
      </div>
      <div className="gestion__wrapper">
        <form onSubmit={handleSubmit(onSubmit)} className="form">
          {/* :TODO: INFO */}
          <div className="form__container">
            <div className="form__inputboxWrapper">
              <Title color={"#183a68"}>Fiche activité :</Title>
              <div className="form__inputboxWrapper" style={{ width: "100%" }}>
                <div className="form__inputbox">
                  <label htmlFor="name" className="form__label">
                    Nom
                  </label>
                  <input
                    name="name"
                    defaultValue={activite?.name}
                    onChange={(e) => setName(e.target.value)}
                    ref={register({ required: "Required" })}
                    className="form__input"
                  />
                  {errors.name && errors.name.message}
                </div>

                <div className="form__inputbox">
                  <label htmlFor="birthday" className="form__label">
                    Classement
                  </label>
                  <input
                    name="classement"
                    defaultValue={activite?.classement}
                    type="number"
                    min="1"
                    ref={register({ required: "Required" })}
                    className="form__input"
                  />
                  {errors.aid && errors.classement.message}
                </div>
              </div>
            </div>

            <div style={{ width: "25%", height: "100%" }}>
              <Title color={"#183a68"}>Activié démo :</Title>
              <div className="card">
                <Heading color={color.hex}>{name}</Heading>
                <Picture image={imageURL ? imageURL : "/img/default_image.png"}>
                  &nbsp;
                </Picture>
              </div>
            </div>
          </div>

          {/* :FIXME: IMAGE & COLOR */}
          <div
            className="form__container"
            style={{ justifyContent: "flex-start", marginBottom: "3rem" }}
          >
            <div className="gestion__imageWrapper">
              <label htmlFor="image" className="form__label">
                Importer une image
              </label>
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                <img
                  src="/img/icon/upload.svg"
                  alt="upload"
                  style={{ width: "120px" }}
                />
              </div>
            </div>

            <div
              className="gestion__colorWrapper"
              style={{ marginLeft: "10rem" }}
            >
              <label htmlFor="color" className="form__label">
                Choisir un color
              </label>
              <div style={{ marginTop: "1rem" }}>
                <ChromePicker
                  color={color}
                  onChange={(color) => setColor(color)}
                />
              </div>
            </div>
          </div>

          <div className="text__container">
            <div className="text__inputContainer">
              <div className="borne__label" style={{ marginBottom: "1rem" }}>
                TEXTE
              </div>
              <div className="">
                <textarea
                  name="topText"
                  ref={register({})}
                  className="text__input"
                  defaultValue={strings["string_1"]?.replace(
                    /<br\s*\/?>/gi,
                    "\n"
                  )}
                  onChange={(e) =>
                    setStrings({
                      string_1: e.target.value,
                      string_2: strings["string_2"],
                    })
                  }
                  style={{
                    width: "100%",
                    fontSize: "1.6rem",
                    marginBottom: "1rem",
                  }}
                  rows="4" // Adjust the rows to set the height of the textarea
                  placeholder="Entrez votre texte du haut ici..."
                />
                <textarea
                  name="bottomText"
                  ref={register({})}
                  className="text__input"
                  defaultValue={strings["string_2"]?.replace(
                    /<br\s*\/?>/gi,
                    "\n"
                  )}
                  onChange={(e) =>
                    setStrings({
                      string_1: strings["string_1"],
                      string_2: e.target.value,
                    })
                  }
                  style={{ width: "100%", fontSize: "1.6rem" }}
                  rows="4"
                  placeholder="Entrez votre texte du bas ici..."
                />
              </div>
            </div>
          </div>

          <div
            className=""
            style={{ display: "flex", marginTop: "3rem", marginBottom: "4rem" }}
          >
            <div className="" style={{ marginRight: "20px" }}>
              <div className="borne__label" style={{ marginBottom: "18px" }}>
                couleur primaire
              </div>
              <TwitterPicker
                color={primaryColor}
                onChange={({ hex }) => setPrimaryColor(hex)}
                colors={[primaryColor]}
              />
            </div>
            <div className="" style={{ marginRight: "20px" }}>
              <div className="borne__label" style={{ marginBottom: "18px" }}>
                couleur secondaire
              </div>
              <TwitterPicker
                color={secondaryColor}
                onChange={({ hex }) => setSecondaryColor(hex)}
                colors={[secondaryColor]}
              />
            </div>
            <div className="">
              <div className="borne__label" style={{ marginBottom: "18px" }}>
                couleur de fond
              </div>
              <TwitterPicker
                color={backgroundColor}
                onChange={({ hex }) => setBackgroundColor(hex)}
                colors={[backgroundColor]}
              />
            </div>
          </div>

          {/* :FIXME: */}
          <div className="" style={{ marginTop: "20px" }}>
            <div className="borne__switch" style={{ width: "260px" }}>
              <div className="borne__label">pied de page</div>
              <Switch
                checked={menu}
                onColor={color.hex}
                onChange={() => setMenu(!menu)}
              />
            </div>
            <div className="gestion__imageWrapper">
              <div className="borne__switch" style={{ width: "260px" }}>
                <div className="borne__label">le bandeau défilant</div>
                <Switch
                  checked={statusSlider}
                  onColor={color.hex}
                  onChange={() => setStatusSlider(!statusSlider)}
                />
              </div>
              <div className="">
                <input
                  ref={fileInputSliderRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageSliderChange}
                  style={{ display: "none" }}
                />
                <img
                  onClick={handleUploadSliderClick}
                  src="/img/icon/upload.svg"
                  alt="upload"
                  style={{ width: "40px", cursor: "pointer" }}
                />
              </div>
            </div>
            <img
              src={imageSlider}
              alt=""
              style={{ width: "100%", marginTop: "10px" }}
              onError={(e) => {
                e.target.onerror = null; // Prevents looping
                e.target.src = `${process.env.REACT_APP_SITE_MARCHAND}/img/default_image_slider.png`; // Path to your default image
              }}
            />
          </div>

          {/* :FIXME: REDIRECTION */}
          <div className="" style={{ marginTop: "30px" }}>
            <div className="borne__switch" style={{ width: "260px" }}>
              <div className="borne__label">redirection externe</div>
              <Switch
                checked={redirectStatus}
                onColor={color.hex}
                onChange={() => setRedirectStatus(!redirectStatus)}
              />
            </div>
            {redirectStatus && (
              <div className="form__inputbox" style={{ marginTop: "1rem" }}>
                <label htmlFor="redirectUrl" className="form__label">
                  URL de redirection
                </label>
                <input
                  name="redirectUrl"
                  defaultValue={activite?.redirectUrl}
                  ref={register()}
                  className="form__input"
                  placeholder="https://exemple.com"
                />
              </div>
            )}
          </div>

          {/* :FIXME: BUTTON */}
          <div className="gestion__buttonWrapper" style={{ marginTop: "20px" }}>
            <button
              className="facture__button"
              style={{
                fontSize: "1.5rem",
                width: "15rem",
                backgroundColor: "#0D53FC",
              }}
            >
              Update
            </button>
            <Link to="/activites">
              <button
                className="facture__button"
                style={{
                  fontSize: "1.5rem",
                  width: "15rem",
                  backgroundColor: "#fc114c",
                }}
              >
                Fermer
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateActivite;
